export default __webpack_public_path__ + "static/news4-a12711e72c225b0e128fff09084d7cd2.jpg";